export default "__VITE_ASSET__f0b04e03__"